import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createOperator } from '@/apis/operator'
import { CUSTOMER_TYPES } from '@/constants/customer'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateOperatorRequest } from '@/types/apis/operators/CreateOperatorRequest'
import { CreateOperatorResponse } from '@/types/apis/operators/CreateOperatorResponse'

export const useCreateOperator = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateOperatorResponse>()

  const create = useCallback(
    async (request: CreateOperatorRequest) => {
      try {
        setLoading(true)
        const res = await createOperator({ ...request, type: CUSTOMER_TYPES[1].id })
        setResponse(res)
        openNotification({ description: t('pages.operators.create.createSuccessfully') })
        navigate(routes.operators.path)
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createOperator: create,
    response,
  }
}
